import Choice from './Choice.vue'
import ImageChoice from './ImageChoice.vue'
import Cascade from './Cascade.vue'
import { getComponentFactory } from 'dygc'

const getComponent = getComponentFactory({ Choice, ImageChoice ,Cascade});

export default {
  props:{
    question:Object
  },
  render(h){
    const Comp = getComponent(this.question.questionType)
    return h(Comp, {
      ref: 'root',
      scopedSlots: this.$scopedSlots,
      props: { ...this.$attrs,question: this.question },
      on: { ...this.$listeners },
      key: this.question.q_id
    })
  }
}